import { createSlice } from '@reduxjs/toolkit';
import { loadingContactReducer } from './reducers/loading-contact.reducer';
import { contactErrorReducer } from './reducers/contact-error.reducer';
import { createCustomerContactReducer } from './reducers/create-contact.reducer';
import { initialContactState } from './state';

export const contactSlice = createSlice({
  name: 'Contact',
  initialState: initialContactState,
  reducers: {
    loading: loadingContactReducer,
    error: contactErrorReducer,
    create: createCustomerContactReducer,
  },
});

export const contactReducer = contactSlice.reducer;
